import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header card-header-stretch" }
const _hoisted_3 = { class: "card-title d-flex align-items-center" }
const _hoisted_4 = { class: "svg-icon svg-icon-1 svg-icon-primary me-3 lh-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0 text-gray-800" }, "Jan 23, 2021", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar m-0" }, [
  /*#__PURE__*/_createElementVNode("ul", {
    class: "nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0 fw-bolder",
    role: "tablist"
  }, [
    /*#__PURE__*/_createElementVNode("li", {
      class: "nav-item",
      role: "presentation"
    }, [
      /*#__PURE__*/_createElementVNode("a", {
        id: "kt_activity_today_tab",
        class: "nav-link justify-content-center text-active-gray-800 active",
        "data-bs-toggle": "tab",
        role: "tab",
        href: "#kt_activity_today"
      }, " Today ")
    ]),
    /*#__PURE__*/_createElementVNode("li", {
      class: "nav-item",
      role: "presentation"
    }, [
      /*#__PURE__*/_createElementVNode("a", {
        id: "kt_activity_week_tab",
        class: "nav-link justify-content-center text-active-gray-800",
        "data-bs-toggle": "tab",
        role: "tab",
        href: "#kt_activity_week"
      }, " Week ")
    ]),
    /*#__PURE__*/_createElementVNode("li", {
      class: "nav-item",
      role: "presentation"
    }, [
      /*#__PURE__*/_createElementVNode("a", {
        id: "kt_activity_month_tab",
        class: "nav-link justify-content-center text-active-gray-800",
        "data-bs-toggle": "tab",
        role: "tab",
        href: "#kt_activity_month"
      }, " Month ")
    ]),
    /*#__PURE__*/_createElementVNode("li", {
      class: "nav-item",
      role: "presentation"
    }, [
      /*#__PURE__*/_createElementVNode("a", {
        id: "kt_activity_year_tab",
        class: "nav-link justify-content-center text-active-gray-800 text-hover-gray-800",
        "data-bs-toggle": "tab",
        role: "tab",
        href: "#kt_activity_year"
      }, " 2021 ")
    ])
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tab-content" }, [
    /*#__PURE__*/_createElementVNode("div", {
      id: "kt_activity_today",
      class: "card-body p-0 tab-pane fade show active",
      role: "tabpanel",
      "aria-labelledby": "kt_activity_today_tab"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "timeline" }, " Lorem ipsum dolor sit amet consectetur adipisicing elit. Unde nihil quos delectus aliquam quas officia ab maxime eius, mollitia nostrum sint ipsa temporibus voluptatem? Exercitationem expedita minus ea omnis molestiae? ")
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      id: "kt_activity_week",
      class: "card-body p-0 tab-pane fade show",
      role: "tabpanel",
      "aria-labelledby": "kt_activity_week_tab"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "timeline" }, " Lorem ipsum dolor sit amet consectetur adipisicing elit. Quam enim eius excepturi nobis sit magni voluptatem ipsa adipisci repudiandae. Culpa id quaerat corrupti ipsum et dolorem nisi illum error officia? ")
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      id: "kt_activity_month",
      class: "card-body p-0 tab-pane fade show",
      role: "tabpanel",
      "aria-labelledby": "kt_activity_month_tab"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "timeline" }, " Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil beatae atque doloremque saepe, reiciendis, perferendis ea aliquam, debitis quaerat corporis earum et illum quam accusamus labore similique voluptatum architecto ratione! ")
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      id: "kt_activity_year",
      class: "card-body p-0 tab-pane fade show",
      role: "tabpanel",
      "aria-labelledby": "kt_activity_year_tab"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "timeline" }, " Lorem, ipsum dolor sit amet consectetur adipisicing elit. Quas quisquam iure ex distinctio ipsam maxime hic nemo odio voluptatum optio officiis doloribus blanditiis totam magni, fuga beatae vero voluptatibus eum? ")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_inline_svg, { src: "svg/icons/gen014.svg" })
        ]),
        _hoisted_5
      ]),
      _hoisted_6
    ]),
    _hoisted_7
  ]))
}